<div class="text-center">
    <a (click)="tryFacebookLogin()" class="btn btn-social-icon mr-1 mb-1 btn-outline-facebook"><span
            class="la la-facebook"></span></a>
    <a (click)="tryTwitterLogin()" class="btn btn-social-icon mr-1 mb-1 btn-outline-twitter"><span
            class="la la-twitter"></span></a>
    <a (click)="tryGoogleLogin()" class="btn btn-social-icon mr-1 mb-1 btn-outline-linkedin"><span
            class="la la-google font-medium-4"></span></a>
    <a (click)="tryGithubLogin()" class="btn btn-social-icon mr-1 mb-1 btn-outline-github"><span
            class="la la-github font-medium-4"></span></a>
</div>